import { render, staticRenderFns } from "./SetupPassword.vue?vue&type=template&id=c0d8ac5a&scoped=true&"
import script from "./SetupPassword.vue?vue&type=script&lang=js&"
export * from "./SetupPassword.vue?vue&type=script&lang=js&"
import style0 from "./SetupPassword.vue?vue&type=style&index=0&id=c0d8ac5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d8ac5a",
  null
  
)

export default component.exports